import styled from "@emotion/styled";
import { css } from "@emotion/react";
import breakpoint from "@shared/styles/breakpoints";

const Styled: any = {};

Styled.Container = styled.div((props) => {
  const t: any = props.theme;
  return css`
    label: Session;
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    overflow-x: auto;
    background-color: ${t.dark ? t.color.gray[900] : t.color.white};
  `;
});

Styled.UI = styled.div(() => {
  return css`
    label: Session_UI;
    display: flex;
    flex-direction: column;
    width: 100%;
    height: calc(100% - 46px);
    align-items: center;
    overflow-y: auto;

  `;
});

Styled.FormContent = styled.div((props: any) => {
  const t = props.theme;
  return css`
    label: Session_FormContent;
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 1;
    width: 100%;
    margin-top: 0;

    ${breakpoint.xs} {
      justify-content: center;
      margin-top: 44px;
    }
  `;
});

Styled.FormContentWrapper = styled(Styled.FormContent)((props: any) => {
  const t: any = props.theme;
  return css`
    label: Session_FormContentWrapper;
    ${[t.mb(2)]}

    ${breakpoint.xs} {
      ${[t.mb(16)]}
    }

    h2 {
      ${[t.pb(6)]}
    }
  `;
});

Styled.Form = styled.div((props) => {
  const t: any = props.theme;
  return css`
    label: Session_Form;
    ${[t.py(8), t.px(4), t.rounded.md]}

    max-width: 427px;
    width: 100%;
    border: 1px solid transparent;
    background-color: ${t.dark ? t.color.gray[900] : t.color.white};
    h2 {
      font-size: 2.25rem;
      font-weight: 700;
      letter-spacing: 0.5px;
      ${[t.mb(3)]};
      color: ${t.dark ? t.color.white : t.color.black};
      text-align: center;
    }

    ul {
      ${[t.mt(8)]}
    }

    ${breakpoint.xxs} {
      ${[t.px(8)]}
    }

    ${breakpoint.xs} {
      border: 1px solid ${t.dark ? t.color.gray[800] : t.color.gray[200]};
      background-color: ${t.dark ? t.color.gray[800] : t.color.white};
    }
  `;
});

Styled.Directions = styled.div((props) => {
  const t: any = props.theme;
  return css`
    label: Session_Directions;
    ${t.mt(-2)};
    p,
    h2 {
      ${[t.mt(4), t.mb(2)]};
      color: ${t.dark ? t.color.gray[400] : t.color.gray[600]};
      a {
        ${[t.text.medium]};
        color: ${t.dark ? t.color.gray[200] : t.color.black};
        &:hover {
          text-decoration: underline;
        }
      }
    }
  `;
});

Styled.Links = styled.div((props) => {
  const t: any = props.theme;
  return css`
    label: Session_Links;
    ${[t.text.xs, t.mt(0), t.pl(0)]}
    color: ${t.dark ? t.color.gray[400] : t.color.gray[600]};
    width: 100%;
    max-width: 427px;
    display: flex;
    justify-content: space-between;
    margin-top: -12px;
    button,
    a {
      ${[t.py(2), t.pr(0), t.pl(4), t.text.normal]}
      color: ${t.dark ? t.color.gray[400] : t.color.gray[600]};
      background: none;
      border: none;
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }

    button:first-child,
    a:first-child {
      ${[t.pl(4)]}
    }

    button:last-child,
    a:last-child {
      ${[t.pr(4)]}
    }

    ${breakpoint.xxs} {
      button,
      a {
        ${[t.px(0)]}
      }

      button:first-child,
      a:first-child {
        ${[t.pl(8)]}
      }

      button:last-child,
      a:last-child {
        ${[t.pr(8)]}
      }
    }

    ${breakpoint.xs} {
      ${[t.px(0), t.mt(4)]}

      button,
      a {
        ${[t.px(1)]}
      }

      button:first-child,
      a:first-child {
        ${[t.pl(0)]}
      }

      button:last-child,
      a:last-child {
        ${[t.pr(0)]}
      }
    }
  `;
});

Styled.RecaptchaContainer = styled.div`
  label: AuthForm_RecaptchaContainer;

  .grecaptcha-badge {
    visibility: hidden;
  }
`;

Styled.Recaptcha = styled.div((props: any) => {
  const t: any = props.theme;
  return css`
    label: Auth_RecaptchaStatement;
    width: 100%;
    position: relative;
    bottom: 0;
    display: flex;
    justify-content: center;
    ${[t.h(14), t.mt(8)]}


    p {
      max-width: 327px;
      ${[t.text.xs, t.h(9), t.mb(1), t.px(4)]}
      line-height: 1.2;
      text-align: center;
      color: ${t.dark ? t.color.gray[500] : t.color.gray[600]};
      a:hover {
        color: ${t.dark ? t.color.gray[300] : t.color.black};
      }
    }
    ${breakpoint.xxs} {
      p {
        line-height: 1.5;
        ${[t.mb(4)]}
      }
    }
  `;
});

Styled.AuthForm = styled.div((props) => {
  const t: any = props.theme;
  return css`
    label: AuthForm;
    ${[t.pb(1)]}
  `;
});

Styled.GoogleSSOWrapper = styled.div((props) => {
  const t: any = props.theme;
  return css`
    label: Session_GoogleSSOWrapper;
    ${t.mt(8)}
  `;
});

Styled.ContinueText = styled.div((props) => {
  const t: any = props.theme;
  return css`
    text-align: center; 
    ${[t.pb(6), t.pt(5)]};
    color: ${t.dark ? t.color.gray[300] : t.color.gray[600]} }
  `;
});

export default Styled;
